import { Form } from "antd"
import React from "react"

import { TextInput } from "../../../../../components/Input/TextInput.tsx"
import { type SignatureBlockProps } from "./SignatureDateBlock.tsx"
import { SignatureFieldsEditor } from "./SignatureFieldsEditor.tsx"

export function InitialSignatureBlock({
  fieldKey,
  initialValue,
  form,
  index,
  disabled,
  isTemplate
}: SignatureBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "signer_label"]}
        label="Signature Label"
        initialValue={initialValue}
      >
        <TextInput placeholder="e.g. Client Signature" />
      </Form.Item>
      {isTemplate && (
        <SignatureFieldsEditor form={form} index={index} disabled={disabled} />
      )}
    </>
  )
}
